

import { faGear } from "@fortawesome/free-solid-svg-icons/faGear";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dialog, DialogContent, DialogTitle, Icon } from '@mui/material'
import { IColuna } from 'app/types/IColuna'
import clsx from 'clsx'
import React, { useContext, useState } from 'react'
import { traduzirNomeColunaMarkup } from './TraduzirNomeColunaMarkup'
import { TelaMarkupContext } from '../../TelaMarkup'
import { PaperArrastavel } from '../../../dialog-arrastavel/PaperArrastavel'

const estiloCotacoesPerdidas = require('./headers.module.scss').default

export type AcoesHeadMarkupProps = {
    colunas: IColuna[],
    exibirIconesAumentarDiminuirFonte?: boolean
    larguraLinha?: number
}

export const AcoesHeadMarkup = (props: AcoesHeadMarkupProps) => {
    const contexto = useContext(TelaMarkupContext)
    const [mostrarFerramentas, setMostrarFerramentas] = useState<boolean>(false)
    const [icon, setIcon] = useState<string>('arrow_drop_up')

    const [exibirSelecaoColunas, setExibirSelecaoDeColunas] = useState(false)


    const selecaoDeColunas = <div className="_grid _grid-cols-1 _grid-flow-row">

        <div className="_flex _flex-row _justify-start _max-w-xs _items-end">
            <div className="_mr-4">
                <input
                    type="checkbox"
                    checked={props.colunas.every(c => c.Selecionada == true)}
                    onChange={e => contexto.onToggleSelecionarTodasColunas(e.target.checked)} />
            </div>

            <b>Todas</b>

        </div>

        {props.colunas.map((coluna, index) => 
        <div
            className="_flex _flex-row _justify-start _max-w-xs _items-end"
            key={`${index}_${coluna.Nome.replace(/\s+/g, '_')}`}
            id={`AcoesHeadMarkup_SelecaoColuna_${coluna.Nome.replace(/\s+/g, '_')}_${index}`}
        >
            <div className="_mr-4">
                <input
                    type="checkbox"
                    id={`AcoesHeadMarkup_CheckboxColuna_${coluna.Nome.replace(/\s+/g, '_')}_${index}`}
                    key={`${index}_Checkbox_${coluna.Nome.replace(/\s+/g, '_')}_${index}`}
                    checked={coluna.Selecionada ?? false}
                    onChange={() => contexto.onToggleColunaSelecionada(coluna.Nome, !coluna.Selecionada)} />
            </div>

            {traduzirNomeColunaMarkup({ nomeColuna: coluna.Nome, exibirNomeReferencia: contexto.exibirNomeReferencia })}
        </div>)}
    </div>

    const selecaoDeColunasDialog = <Dialog open={exibirSelecaoColunas} onClose={() => setExibirSelecaoDeColunas(false)} PaperComponent={PaperArrastavel}>
        <DialogTitle>
            Selecionar colunas para exibição
        </DialogTitle>
        <DialogContent>
            {selecaoDeColunas}
        </DialogContent>
    </Dialog>

    const botoes = <div style={{
        width: props.larguraLinha != undefined ? `${props.larguraLinha}px` : undefined

    }} className={clsx(["_flex _flex-row _mt-4 _gap-x-2", estiloCotacoesPerdidas.acoesHead])}
        id="AcoesHeadMarkup_divPrincipal"
    >

        {(contexto.permiteEngrenagemGrid ?? false) && <>
            <FontAwesomeIcon icon={faGear} className="_text-2xl _cursor-pointer" 
                onClick={() => setExibirSelecaoDeColunas(true)} 
                id="AcoesHeadMarkup_IconeSelecaoColunas"
            />
        </>}


        {(props.exibirIconesAumentarDiminuirFonte ?? true) && <>
            <button
                className={clsx('no-global-button', estiloCotacoesPerdidas.botaoAumentarDiminuirFonte)}
                onClick={() => contexto.onAlterarFonte?.(contexto.tamanhoFontePadrao + 1)}
                id="AcoesHeadMarkup_AumentarFonte"
                disabled={contexto.tamanhoFontePadrao >= 26}
            >A+
            </button>
            <button

                className={clsx('no-global-button', estiloCotacoesPerdidas.botaoAumentarDiminuirFonte)}
                onClick={() => contexto.onAlterarFonte?.(contexto.tamanhoFontePadrao - 1)}
                id="AcoesHeadMarkup_DiminuirFonte"
                disabled={contexto.tamanhoFontePadrao <= 8}
            >A-
            </button></>}
    </div>

    const iconeExibirEsconderOpcoes = (
        <button
            style={{ marginLeft: '14px', height: '20px' }}
            id="AcoesHeadMarkup_table-headgrid-itensarrow"
            className="no-global-button"
            onClick={() => {
                setMostrarFerramentas(!mostrarFerramentas);
                setIcon(icon == "arrow_drop_up" ? "arrow_drop_down" : "arrow_drop_up");
            }}
        >
            <Icon>{icon}</Icon>
        </button>
    );

    return <>
        <div className={estiloCotacoesPerdidas.menu}
            id="AcoesHeadMarkup_Div"
        >
            {iconeExibirEsconderOpcoes}
            {mostrarFerramentas && (
                <section>
                    {botoes}
                </section>
            )}
        </div>

        {exibirSelecaoColunas && selecaoDeColunasDialog}
    </>
}
